(()=>{
  const forms=new WeakMap(),t=window.OukumenTheme?.t||{};
  const matches=(variant,values,end=values.length)=>values.every((value,index)=>index>=end||!value||variant.values[index]===value);
  function draw(state){
    for(const button of state.buttons){
      const index=Number(button.dataset.nativePosition),value=button.dataset.nativeChoice;
      button.disabled=!state.variants.some(variant=>!variant.option.disabled&&variant.values[index]===value&&matches(variant,state.values,index));
      button.setAttribute('aria-pressed',String(state.values[index]===value));
    }
    state.groups.forEach((group,index)=>{const output=group.querySelector('[data-native-selected-value]');if(output)output.textContent=state.values[index]||'';});
    const selected=state.values.every(Boolean)?state.variants.filter(variant=>!variant.option.disabled&&matches(variant,state.values)):[];
    state.select.value=selected.length===1?selected[0].option.value:'';
    const output=state.container.querySelector('[data-native-option-status]');
    if(output)output.textContent=state.select.value?state.values.join(' / '):t.choose||'Choose your options';
  }
  function initialize(root=document){
    root.querySelectorAll('[data-product-form]').forEach(form=>{
      if(forms.has(form))return;
      const select=form.querySelector('[data-native-variant]'),container=form.querySelector('[data-native-option-picker]');
      if(!select||!container)return;
      const groups=[...container.querySelectorAll('[data-native-option-group]')],buttons=[...container.querySelectorAll('[data-native-choice]')];
      let variants;
      try{variants=[...select.options].filter(option=>option.value).map(option=>({option,values:JSON.parse(option.dataset.optionValues)}));}catch{return;}
      if(!groups.length||!variants.length||variants.some(variant=>!Array.isArray(variant.values)||variant.values.length!==groups.length))return;
      const selected=variants.find(variant=>variant.option.value===select.value&&!variant.option.disabled);
      const state={select,container,groups,buttons,variants,values:selected?[...selected.values]:groups.map(()=>''),changing:false};forms.set(form,state);draw(state);
      const fallback=form.querySelector('[data-native-variant-fallback]');if(fallback)fallback.hidden=true;container.hidden=false;
    });
  }
  function preview(select){
    const state=forms.get(select.closest('form'));if(!state||!state.values.some(Boolean))return null;
    return state.variants.filter(variant=>!variant.option.disabled&&matches(variant,state.values)).reduce((best,variant)=>!best||Number(variant.option.dataset.priceValue)<Number(best.option.dataset.priceValue)?variant:best,null)?.option||null;
  }
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-native-choice]');if(!button||button.disabled)return;
    const state=forms.get(button.closest('form'));if(!state)return;
    const index=Number(button.dataset.nativePosition);state.values[index]=button.dataset.nativeChoice;
    for(let next=index+1;next<state.values.length;next++)if(state.values[next]&&!state.variants.some(variant=>!variant.option.disabled&&matches(variant,state.values,next+1)))state.values[next]='';
    draw(state);state.changing=true;state.select.dispatchEvent(new Event('change',{bubbles:true}));state.changing=false;
  });
  document.addEventListener('change',event=>{
    const select=event.target.closest('[data-native-variant]'),state=select&&forms.get(select.closest('form'));if(!state||state.changing)return;
    const selected=state.variants.find(variant=>variant.option.value===select.value&&!variant.option.disabled);state.values=selected?[...selected.values]:state.groups.map(()=>'');draw(state);
  });
  window.OukumenVariants={initialize,preview};
})();
